var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.to !== '')?_c('a',{class:_vm.classes,attrs:{"href":_vm.to},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_c('div',{class:_vm.classes,on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }